/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_GoogleInputs */

const en_auth_login_google = /** @type {(inputs: Auth_Login_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login with Google`)
};

/**
* | output |
* | --- |
* | "Login with Google" |
*
* @param {Auth_Login_GoogleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_google = /** @type {((inputs?: Auth_Login_GoogleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_GoogleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_google(inputs)
});